import { render, staticRenderFns } from "./buttonRenderer.vue?vue&type=template&id=463f01fe&scoped=true&"
import script from "./buttonRenderer.vue?vue&type=script&lang=js&"
export * from "./buttonRenderer.vue?vue&type=script&lang=js&"
import style0 from "./buttonRenderer.vue?vue&type=style&index=0&id=463f01fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463f01fe",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/mnt/c/Users/tes028/source/Tesfri/logistic-variant-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('463f01fe')) {
      api.createRecord('463f01fe', component.options)
    } else {
      api.reload('463f01fe', component.options)
    }
    module.hot.accept("./buttonRenderer.vue?vue&type=template&id=463f01fe&scoped=true&", function () {
      api.rerender('463f01fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/logisticVariant/logisticVariant/components/list/renderer/buttonRenderer.vue"
export default component.exports